import styled from "styled-components";
import { SolutionColorVariables } from "@smartsuite/types";

export const WelcomeStyles = styled.div`
  background-color: ${SolutionColorVariables.sc2};

  .welcome-automation-content {
    max-height: 75vh;

    &-wrapper {
      text-align: center;
      padding: 60px 30px;
    }

    &-inner {
      max-width: 670px;
      margin: 0 auto;
    }
  }

  .welcome-text {
    margin-bottom: 36px;
  }

  .create-first-button {
    display: inline-block;
  }
`;
